import React, { createContext, PropsWithChildren, useMemo } from 'react';
import type { ServicesApiClient } from '@feedfm/clips-services-api-client';
import { getClipsClient } from '~/services/clips';

export const ClipsContext = createContext<ServicesApiClient | null>( null );

/**
 * Provides the Clips Services API client to descendant components. Use `useClipsClient()` to consume.
 */
export function ClipsContextProvider( props: PropsWithChildren<object> ) {
  const client = useMemo( () => getClipsClient(), [] );
  return <ClipsContext.Provider value={ client }>{ props.children }</ClipsContext.Provider>;
}
